import { createActionRoute, createSiteRoute } from '@townsquare/router/create-route';
import { SiteHomePageRoute } from '@townsquare/router/route-types';

export const followGoalActionRoute: SiteHomePageRoute = createSiteRoute(
	createActionRoute({
		exact: true,
		name: 'followGoalAction',
		path: '/goal/:key/:action(follow|unfollow)',
	}),
);
